import React from 'react'
import { 
  Box, 
  Typography, 
  useTheme, 
  Button, 
  Grid, 
  Chip, 
  Modal, 
  TextField,
  Snackbar,
  IconButton,
  Tooltip,
  CircularProgress,
  Divider,
  Backdrop
} from "@mui/material";
import { tokens } from "../theme";
import { useState, useContext, useEffect } from "react";
import { ColorModeContext, useMode } from "../theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import AuthContext from "../auth/AuthProvider";
import { Topbar } from '../layouts/Topbar';
import Sidebarr from '../layouts/Sidebar';
import Header from "../components/Header";
import { useLocation, useNavigate } from 'react-router-dom';
import {api} from "../api";
import { fetchToken } from '../auth/Token';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CloseIcon from '@mui/icons-material/Close';
import ViewAgendaIcon from '@mui/icons-material/ViewAgenda';
import { SocietyDash } from './SocietyDash';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { toast } from 'sonner';




export const Dashboard = ({isOnline}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const go = location.state && location.state.go;
    const [personaInfo, setPersonaInfo] = useState([]);
    const [detailsInfo, setDetailsInfo] = useState([]);
    const {  permissions } = useContext(AuthContext);
    const [value, setValue] = React.useState('1');
    const [societies, setSocieties] = useState([]);
    const [unions, setUnions] = useState([]);
    const [apexes, setApexes] = useState([]);
    const [modal_open, setModal_open] = useState(false);
    const [modal_open_e, setModal_open_e] = useState(false);
    const [modal_thing, setModal_thing] = useState('');
    const [selected_guys, setSelected_guys] = useState([]);
    const [name, setName] = useState('');
    const [ope, setOpe] = useState(false);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [backdrop_open, setBackdrop_open] = useState(false)
    const [incoming_id, setIncoming_id] = useState()
    const [society_id, setSociety_id] = useState(0)
    const [society_dash, setSociety_dash] = useState(<SocietyDash society_id={17} isOnline={isOnline} />)



    

    const DeleteUnionApex = () => {
      handleBackdropOpen();
      const data = new FormData()
      data.append('id', incoming_id)
      data.append('thing', modal_thing)

      api.post('/dashboards/delete/union/or/apex', data, {
        headers: {
          Authorization: 'Bearer '+fetchToken()
        }
      }).then(function (response){
        toast.success(response.data)
        close_modal();
        fetch_things();
      }).catch(function (error){
        console.log(error)
      }).finally(function(){
        handleBackdropClose();
      })
    }

    const handleBackdropClose = () => {
      setBackdrop_open(false);
    };
    const handleBackdropOpen = () => {
      setBackdrop_open(true);
    };

    const handleEditModal = (id, thing) => {
      handleBackdropOpen();
      setModal_thing(thing);
      const data = new FormData()
      data.append('id', id)
      data.append('thing', thing)

      api.post('/dashboards/details/for/edit', data, {
        headers: {
          Authorization: 'Bearer '+fetchToken()
        }
      }).then(function (response){
          setModal_open_e(true);
          setIncoming_id(response.data[0]?.id);
          setName(response.data[0]?.name);
          setSelected_guys(response.data[0]?.kids);
          setModal_thing(thing);
      }).catch(function (error){
        console.log(error)
      }).finally(function(){
        handleBackdropClose();
      })
    }

    const handleClo = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }
      setOpe(false);
    };

    const actio = (
      <React.Fragment>
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={handleClo}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </React.Fragment>
    );

    const createThing = () => {
      setLoading(true)
      const data = {
        'name': name,
        'things': selected_guys,
        'id': incoming_id?incoming_id:0
      }
      if(modal_thing === 'Union'){
        api.post('/association/build/union', data, {
          headers: {
            Authorization: 'Bearer '+fetchToken()
          }
        }).then(function (response){
            toast.success(response.data)
            if(response.data !== "Union Already Exist"){
              close_modal();
            }
            fetch_things();
        }).catch(function (error){
          console.log(error)
        }).finally(function(){
          setLoading(false)
        })
      }else{
        api.post('/association/build/apex', data, {
          headers: {
            Authorization: 'Bearer '+fetchToken()
          }
        }).then(function (response){
            toast.success(response.data)
            if(response.data !== "Apex Already Exist"){
              close_modal();
            }
            fetch_things();
        }).catch(function (error){
          console.log(error)
        }).finally(function(){
          setLoading(false)
        })
      }
    }

    const close_modal = () => {
      setModal_open(false);
      setModal_open_e(false);
      setModal_thing('');
      setSelected_guys([]);
    }

    const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 600,
      maxHeight: '80vh', 
      overflowY: 'auto', 
      '&::-webkit-scrollbar': {
          width: '7px',
          height: '7px',
      },
      '&::-webkit-scrollbar-track': {
          background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
          background: '#888',
          borderRadius: '10px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
          background: '#555',
      },
      bgcolor: 'background.paper',
      border: '1px solid #e7ecef',
      borderRadius: '7px',
      boxShadow: 24,
      p: 4,
    };

    const handleOpenModal = (thing) => {
      setModal_open(true);
      setModal_thing(thing);
    }


    const fetch_things = () => {
      const storedSocieties = localStorage.getItem('societies');
      const storedUnions = localStorage.getItem('unions');
      const storedApexes = localStorage.getItem('apexes');
    
      if (!isOnline) {
        setSocieties(JSON.parse(storedSocieties));
      } else {
        api.get('/association/societies/allshch', {
          headers: {
            Authorization: 'Bearer ' + fetchToken(),
          }})
          .then(function (response) {
            setSocieties(response.data?.Society);
            localStorage.setItem('societies', JSON.stringify(response.data?.Society));
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    
      if (!isOnline) {
        setUnions(JSON.parse(storedUnions));
      } else {
        api.get('/association/unions/allshch', {
          headers: {
            Authorization: 'Bearer ' + fetchToken(),
          }})
          .then(function (response) {
            setUnions(response.data?.Unions);
            localStorage.setItem('unions', JSON.stringify(response.data?.Unions));
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    
      if (!isOnline) {
        setApexes(JSON.parse(storedApexes));
      } else {
        api.get('/association/apexes/allshch', {
          headers: {
            Authorization: 'Bearer ' + fetchToken(),
          }})
          .then(function (response) {
            setApexes(response.data?.Apexes);
            localStorage.setItem('apexes', JSON.stringify(response.data?.Apexes));
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    };


  const handleDisplaySociety = (society_id) => {
    setSociety_id(society_id)
    setSociety_dash(
      <SocietyDash society_id={society_id}  isOnline={isOnline} />
    )
  }


  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const fetchPersona = () => {
    const storedPersona = localStorage.getItem('persona_info');
  
    if (!isOnline) {
      setPersonaInfo(JSON.parse(storedPersona));
    } else {
      api.get('/users/su', {
        headers: {
          Authorization: 'Bearer ' + fetchToken(),
        },
      })
        .then(function (response) {
          setPersonaInfo(response.data);
          localStorage.setItem('persona_info', JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };
  
  
    const fetchUserDetailAll = () =>{
      api.get('/users/details/all',{
          headers: {
              Authorization: 'Bearer '+ fetchToken()
          }
        }).then(function (response){
            setDetailsInfo(response.data?.details);
        }).catch(function (error){
          console.log(error)
        })
    }
  
    useEffect(() => {
      fetchPersona();
      fetch_things();
      fetchUserDetailAll()
    }, [])
    
    if(go === "Go"){
      navigate('/profile/page',{state: {
        personaInfo: personaInfo,
        detailsInfo: detailsInfo
      }})
    }
  return (
      <div className="app">
            <Box sx={{ m:1 }}>
              <Grid container spacing={2}>

                <Grid item xs={12} md={12}>
                    <TabContext  value={value}>
                        <TabList onChange={handleChange} sx={{ 
                              m: 'auto',
                              display: 'flex',
                              flexDirection: 'row',
                              justifyContent: 'center',
                              backgroundColor: '#ffffff',
                              borderWidth: 2,
                              borderRadius: 4,
                              p: 0,
                              maxWidth: '22%',
                              alignItems: 'center',
                            }} aria-label="lab API tabs example">
                          <Tab sx={{
                              pt: 0,
                              pb: 0,
                              pr: 1, 
                              pl: 1,
                              backgroundColor: '#ffffff',
                              borderRadius: 4,
                              borderWidth:'2px',
                              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                              m:'8px'
                            }} label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Societies</b></Typography>} value="1" />
                          <Tab sx={{
                              pt: 0,
                              pb: 0,
                              pr: 1, 
                              pl: 1,
                              backgroundColor: '#ffffff',
                              borderRadius: 4,
                              borderWidth:'2px',
                              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                              m:'8px'
                            }} label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Unions</b></Typography>} value="2" />
                          <Tab sx={{
                              pt: 0,
                              pb: 0,
                              pr: 1, 
                              pl: 1,
                              backgroundColor: '#ffffff',
                              borderRadius: 4,
                              borderWidth:'2px',
                              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                              m:'8px',
                              mr:'5px'
                            }} label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Apex</b></Typography>} value="3" />
                        </TabList>
                      
                      <Grid container spacing={2}>

                        <Grid item xs={12} md={12}>
                          {/* Societies */}
                          <TabPanel value="1">
                            <Grid container spacing={2}>
                              <Grid item xs={12} md={12}>
                              <Box 
                                sx={{ 
                                    display:'flex',
                                    overflowX: 'auto', 
                                    marginTop:'5px',
                                    maxWidth: 1400, 
                                    '&::-webkit-scrollbar': {
                                      height: '5px',
                                    },
                                    '&::-webkit-scrollbar-track': {
                                        background: '#f1f1f1',
                                    },
                                    '&::-webkit-scrollbar-thumb': {
                                        background: '#888',
                                        borderRadius: '10px',
                                    },
                                    '&::-webkit-scrollbar-thumb:hover': {
                                        background: '#555',
                                    }
                                }}
                              >
                              
                                {
                                  societies?
                                  societies.map((item)=>(
                                    <Chip 
                                      key={item.id} 
                                      size='small'
                                      label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{item.society}</b></Typography>}
                                      sx={{
                                        borderRadius:2,
                                        m:1,
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                        backgroundColor:'#2b2d42',
                                        color:'#fff',
                                        '&:hover': {
                                          boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                          backgroundColor:'#14213d',
                                        },
                                      }} 
                                      onClick={() => handleDisplaySociety(item.id)} 
                                    />
                                  ))
                                  :<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">Societies will appear here</Typography>
                                }
                              </Box>
                              </Grid>
                                {society_dash}
                              
                            </Grid>
                          </TabPanel>

                          <TabPanel value="2">
                            {/* Unions */}
                            <Grid container spacing={2}>
                              <Grid item xs={12} md={12}>
                              <Box 
                                sx={{ 
                                    display:'flex',
                                    overflowX: 'auto', 
                                    marginTop:'5px',
                                    maxWidth: 1400, 
                                    '&::-webkit-scrollbar': {
                                      height: '5px',
                                    },
                                    '&::-webkit-scrollbar-track': {
                                        background: '#f1f1f1',
                                    },
                                    '&::-webkit-scrollbar-thumb': {
                                        background: '#888',
                                        borderRadius: '10px',
                                    },
                                    '&::-webkit-scrollbar-thumb:hover': {
                                        background: '#555',
                                    }
                                }}
                              >
                              
                                {
                                  unions && unions[0]?
                                  <>
                                  <Tooltip title='New Union'>
                                    <IconButton onClick={() => handleOpenModal('Union')}>
                                      <AddCircleIcon sx={{ color:'2b2d42' }}/>
                                    </IconButton>
                                  </Tooltip>
                                  {
                                    unions && unions.map((item) => (
                                      <Tooltip title={(
                                        <Grid container spacing={2}>
                                          <Grid item xs={12} md={12}>
                                            <Typography textAlign='center' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                              <b> Societies</b> 
                                            </Typography>
                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                              <b>Update</b> 
                                              <IconButton onClick={() => handleEditModal(item.id, 'Union')}><ViewAgendaIcon color='action'/></IconButton>
                                            </Typography>
                                          </Grid>
                                            {
                                              item.societies?.map((two) => (
                                                <Grid item xs={12} md={12}>
                                                  <Typography textAlign='left' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                    <b>{two.society}</b> 
                                                  </Typography>
                                                  <Divider variant='middle'/>
                                                </Grid>
                                              ))
                                            }
                                        </Grid>
                                      )}>
                                        <Chip 
                                          key={item.id} 
                                          size='small'
                                          label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{item.union_name}</b></Typography>}
                                          sx={{
                                            borderRadius:2,
                                            m:1,
                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                            backgroundColor:'#2b2d42',
                                            color:'#fff',
                                            '&:hover': {
                                              boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                              backgroundColor:'#14213d',
                                            },
                                          }} 
                                          // onClick={() => handleDisplaySociety(item.id, item.society)} 
                                        />
                                      </Tooltip>
                                        
                                    ))
                                  }
                                  </>
                                  :
                                  <Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Unions will appear here</b>
                                      <Chip
                                        size='small'
                                        label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Build Union</b></Typography>}
                                        sx={{
                                          borderRadius:2,
                                          m:1,
                                          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                          backgroundColor:'#2b2d42',
                                          color:'#fff',
                                          '&:hover': {
                                            boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                            backgroundColor:'#14213d',
                                          },
                                        }} 
                                        onClick={() => handleOpenModal('Union')} 
                                      />
                                  </Typography>
                                }
                              </Box>
                              </Grid>
                            </Grid>

                          </TabPanel>
                          <TabPanel value="3">
                            {/* Apexes */}
                          <Grid container spacing={2}>
                              <Grid item xs={12} md={12}>
                              <Box 
                                sx={{ 
                                    display:'flex',
                                    overflowX: 'auto', 
                                    marginTop:'5px',
                                    maxWidth: 1400, 
                                    '&::-webkit-scrollbar': {
                                      height: '5px',
                                    },
                                    '&::-webkit-scrollbar-track': {
                                        background: '#f1f1f1',
                                    },
                                    '&::-webkit-scrollbar-thumb': {
                                        background: '#888',
                                        borderRadius: '10px',
                                    },
                                    '&::-webkit-scrollbar-thumb:hover': {
                                        background: '#555',
                                    }
                                }}
                              >
                              
                                {
                                  apexes && apexes[0]?
                                  <>
                                    <Tooltip title='New Apex'>
                                      <IconButton onClick={() => handleOpenModal('Apex')}>
                                        <AddCircleIcon sx={{ color:'2b2d42' }}/>
                                      </IconButton>
                                    </Tooltip>
                                    {
                                      apexes && apexes.map((item) => (

                                        <Tooltip title={(
                                            <Grid container spacing={2}>
                                              <Grid item xs={12} md={12}>
                                                <Typography textAlign='center' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                  <b>Unions</b> 
                                                </Typography>
                                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>Update</b> 
                                                <IconButton onClick={() => handleEditModal(item.id, 'Apex')}><ViewAgendaIcon color='action'/></IconButton>
                                              </Typography>
                                              </Grid>
                                                {
                                                  item.unions?.map((two) => (
                                                    <Grid item xs={12} md={12}>
                                                      <Typography textAlign='left' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                        <b>{two.union_name}</b> 
                                                      </Typography>
                                                      <Divider variant='middle'/>
                                                    </Grid>
                                                  ))
                                                }
                                            </Grid>
                                          )}>
                                          <Chip 
                                            key={item.id} 
                                            size='small'
                                            label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{item.apex_name}</b></Typography>}
                                            sx={{
                                              borderRadius:2,
                                              m:1,
                                              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                              backgroundColor:'#2b2d42',
                                              color:'#fff',
                                              '&:hover': {
                                                boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                                backgroundColor:'#14213d',
                                              },
                                            }} 
                                            // onClick={() => handleDisplaySociety(item.id, item.apex_name)} 
                                          />
                                        </Tooltip>
                                          
                                      ))
                                    }
                                  </>
                                  :<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Apexes will appear here</b>
                                    <Chip
                                      size='small'
                                      label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Build an Apex</b></Typography>}
                                      sx={{
                                        borderRadius:2,
                                        m:1,
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                        backgroundColor:'#2b2d42',
                                        color:'#fff',
                                        '&:hover': {
                                          boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                          backgroundColor:'#14213d',
                                        },
                                      }} 
                                      onClick={() => handleOpenModal('Apex')} 
                                    />
                                </Typography>
                                }
                              </Box>
                              </Grid>
                            </Grid>
                          </TabPanel>
                        </Grid>

                      </Grid>
                    </TabContext>
                    
                </Grid>

              </Grid>
                  <Modal
                    open={modal_open}
                    onClose={close_modal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  > 
                    <Box sx={style}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                          <Typography variant='h5' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Build {modal_thing}</b>
                          </Typography>   
                        </Grid>
                        
                        <Grid item xs={12} md={12}>
                          <Box 
                            sx={{ 
                              display:'block',
                              overflowY: 'auto', 
                              maxHeight: 150, 
                              '&::-webkit-scrollbar': {
                                width: '5px',
                                height: '5px',
                              },
                              '&::-webkit-scrollbar-track': {
                                  background: '#f1f1f1',
                              },
                              '&::-webkit-scrollbar-thumb': {
                                  background: '#888',
                                  borderRadius: '10px',
                              },
                              '&::-webkit-scrollbar-thumb:hover': {
                                  background: '#555',
                              }
                            }}
                          >
                            {
                              modal_thing === 'Union'?
                              societies.map((item)=>(
                                <div>
                                  <Chip 
                                    key={item.id} 
                                    size='small'
                                    label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{item.society}</b></Typography>}
                                    sx={{
                                      borderRadius:2,
                                      m:1,
                                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                      backgroundColor: selected_guys.find(one => one.id === item.id) ? '#006400' : '#2b2d42',
                                      color: '#fff',
                                      '&:hover': {
                                        boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                        backgroundColor:'#003566',
                                        color:'#fff'
                                      },
                                    }} 
                                    onClick={() => {
                                      if (!selected_guys.find(one => one.id === item.id)) {
                                        setSelected_guys([...selected_guys, {'id': item.id, 'name': item.society}]);
                                      } else {
                                        setSelected_guys(selected_guys.filter(one => one.id !== item.id));
                                      }
                                    }} 
                                  />
                                </div>
                              ))
                              :modal_thing === 'Apex'?
                              unions.map((item)=>(
                                <Chip 
                                  key={item.id} 
                                  size='small'
                                  label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{item.union_name}</b></Typography>}
                                  sx={{
                                    borderRadius:2,
                                    m:1,
                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                    backgroundColor: selected_guys.find(one => one.id === item.id) ? '#006400' : '#2b2d42',
                                    color: '#fff',
                                    '&:hover': {
                                      boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                      backgroundColor:'#003566',
                                      color:'#fff'
                                    },
                                  }} 
                                  onClick={() => {
                                    if (!selected_guys.find(one => one.id === item.id)) {
                                      setSelected_guys([...selected_guys, {'id': item.id, 'name': item.union_name}]);
                                    } else {
                                      setSelected_guys(selected_guys.filter(one => one.id !== item.id));
                                    }
                                  }}  
                                />
                              ))
                              :null
                            }
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <TextField 
                              size='small'
                              fullWidth
                              name='name'
                              value={name}
                              onChange={(e) => setName(e.target.value)}
                              label={`${modal_thing} Name`}
                            />
                        </Grid>

                        <Grid item xs={12} md={12}>
                          <Typography sx={{textAlign: 'center'}} variant='h6' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{name} {modal_thing === 'Union'?'Societies': 'Unions'}</b>
                          </Typography>
                          <Box 
                              sx={{ 
                                display:'flex',
                                flexWrap:'wrap',
                                overflowY: 'auto', 
                                backgroundColor:'#fbfefb',
                                maxHeight: 150, 
                                borderRadius:4,
                                '&::-webkit-scrollbar': {
                                  width: '5px',
                                  height: '5px',
                                },
                                '&::-webkit-scrollbar-track': {
                                    background: '#f1f1f1',
                                },
                                '&::-webkit-scrollbar-thumb': {
                                    background: '#888',
                                    borderRadius: '10px',
                                },
                                '&::-webkit-scrollbar-thumb:hover': {
                                    background: '#555',
                                }
                              }}
                            >
                                {
                                  selected_guys.map((item)=>(
                                    <Chip 
                                      key={item.id} 
                                      size='small'
                                      label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{item.name}</b></Typography>}
                                      sx={{
                                        borderRadius:2,
                                        m:1,
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                        backgroundColor:'#2b2d42',
                                        maxWidth:120,
                                        color:'#fff',
                                        '&:hover': {
                                          boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                          backgroundColor:'#14213d',
                                        },
                                      }} 
                                    />
                                  ))
                                }
                            </Box>
                        </Grid>

                        <Grid item xs={12} md={12}>
                          <Button
                            size='small'
                            color='error'
                            variant='contained'
                            sx={{
                              borderRadius:2,
                              m:1,
                              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                              '&:hover': {
                                boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                backgroundColor:'#14213d',
                              },
                            }} 
                            onClick={close_modal}
                          >
                            Close
                          </Button>

                          <Button
                            size='small'
                            color='success'
                            variant='contained'
                            sx={{
                              borderRadius:2,
                              m:1,
                              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                              '&:hover': {
                                boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                backgroundColor:'#14213d',
                              },
                            }} 
                            onClick={createThing}
                            // disabled={loading}
                          >
                            {loading? <CircularProgress size='20' sx={{ m:'auto' }} /> : 'Create'}
                          </Button>
                        </Grid>

                      </Grid>
                    </Box>
                  </Modal>
                
                {/* edit form */}

                  <Modal
                    open={modal_open_e}
                    onClose={close_modal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  > 
                    <Box sx={style}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                          <Typography variant='h5' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Update or Delete {modal_thing}</b>
                          </Typography>   
                        </Grid>
                        
                        <Grid item xs={12} md={12}>
                          <Box 
                            sx={{ 
                              display:'block',
                              overflowY: 'auto', 
                              maxHeight: 150, 
                              '&::-webkit-scrollbar': {
                                width: '5px',
                                height: '5px',
                              },
                              '&::-webkit-scrollbar-track': {
                                  background: '#f1f1f1',
                              },
                              '&::-webkit-scrollbar-thumb': {
                                  background: '#888',
                                  borderRadius: '10px',
                              },
                              '&::-webkit-scrollbar-thumb:hover': {
                                  background: '#555',
                              }
                            }}
                          >
                            {
                              modal_thing === 'Union'?
                              societies.map((item)=>(
                                <div>
                                  <Chip 
                                    key={item.id} 
                                    size='small'
                                    label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{item.society}</b></Typography>}
                                    sx={{
                                      borderRadius:2,
                                      m:1,
                                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                      backgroundColor: selected_guys.find(one => one.id === item.id) ? '#006400' : '#2b2d42',
                                      color: '#fff',
                                      '&:hover': {
                                        boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                        backgroundColor:'#003566',
                                        color:'#fff'
                                      },
                                    }} 
                                    onClick={() => {
                                      if(modal_thing === 'Union'){
                                        if (!selected_guys.find(one => one.id === item.id)) {
                                          setSelected_guys([...selected_guys, {'id': item.id, 'society': item.society}]);
                                        } else {
                                          setSelected_guys(selected_guys.filter(one => one.id !== item.id));
                                        }
                                      }else{
                                        if (!selected_guys.find(one => one.id === item.id)) {
                                          setSelected_guys([...selected_guys, {'id': item.id, 'union_name': item.society}]);
                                        } else {
                                          setSelected_guys(selected_guys.filter(one => one.id !== item.id));
                                        }
                                      }
                                      
                                    }} 
                                  />
                                </div>
                              ))
                              :modal_thing === 'Apex'?
                              unions.map((item)=>(
                                <Chip 
                                  key={item.id} 
                                  size='small'
                                  label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{item.union_name}</b></Typography>}
                                  sx={{
                                    borderRadius:2,
                                    m:1,
                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                    backgroundColor: selected_guys.find(one => one.id === item.id) ? '#006400' : '#2b2d42',
                                    color: '#fff',
                                    '&:hover': {
                                      boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                      backgroundColor:'#003566',
                                      color:'#fff'
                                    },
                                  }} 
                                  onClick={() => {
                                    if(modal_thing === 'Apex'){
                                      if (!selected_guys.find(one => one.id === item.id)) {
                                        setSelected_guys([...selected_guys, {'id': item.id, 'union_name': item.union_name}]);
                                      } else {
                                        setSelected_guys(selected_guys.filter(one => one.id !== item.id));
                                      }
                                    }else{
                                      if (!selected_guys.find(one => one.id === item.id)) {
                                        setSelected_guys([...selected_guys, {'id': item.id, 'society': item.union_name}]);
                                      } else {
                                        setSelected_guys(selected_guys.filter(one => one.id !== item.id));
                                      }
                                    }
                                  }}  
                                />
                              ))
                              :null
                            }
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <TextField 
                              size='small'
                              fullWidth
                              name='name'
                              value={name}
                              onChange={(e) => setName(e.target.value)}
                              label={`${modal_thing} Name`}
                            />
                        </Grid>

                        <Grid item xs={12} md={12}>
                          <Typography sx={{textAlign: 'center'}} variant='h6' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{name} {modal_thing === 'Union'?'Societies': 'Unions'}</b>
                          </Typography>
                          <Box 
                              sx={{ 
                                display:'flex',
                                flexWrap:'wrap',
                                overflowY: 'auto', 
                                backgroundColor:'#fbfefb',
                                maxHeight: 150, 
                                borderRadius:4,
                                '&::-webkit-scrollbar': {
                                  width: '5px',
                                  height: '5px',
                                },
                                '&::-webkit-scrollbar-track': {
                                    background: '#f1f1f1',
                                },
                                '&::-webkit-scrollbar-thumb': {
                                    background: '#888',
                                    borderRadius: '10px',
                                },
                                '&::-webkit-scrollbar-thumb:hover': {
                                    background: '#555',
                                }
                              }}
                            >
                                {
                                  selected_guys.map((item)=>(
                                    <Chip 
                                      key={item.id} 
                                      size='small'
                                      label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{modal_thing === 'Union'? item.society :item.union_name}</b></Typography>}
                                      sx={{
                                        borderRadius:2,
                                        m:1,
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                        backgroundColor:'#2b2d42',
                                        maxWidth:120,
                                        color:'#fff',
                                        '&:hover': {
                                          boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                          backgroundColor:'#14213d',
                                        },
                                      }} 
                                    />
                                  ))
                                }
                            </Box>
                        </Grid>

                        <Grid item xs={12} md={12}>
                          <Button
                            size='small'
                            color='error'
                            variant='contained'
                            sx={{
                              borderRadius:2,
                              m:1,
                              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                              '&:hover': {
                                boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                backgroundColor:'#14213d',
                              },
                            }} 
                            onClick={close_modal}
                          >
                            Close
                          </Button>

                          <Button
                            size='small'
                            color='error'
                            variant='contained'
                            sx={{
                              borderRadius:2,
                              m:1,
                              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                              '&:hover': {
                                boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                backgroundColor:'#14213d',
                              },
                            }} 
                            onClick={DeleteUnionApex}
                          >
                            Delete {modal_thing}
                          </Button>

                          <Button
                            size='small'
                            color='success'
                            variant='contained'
                            sx={{
                              borderRadius:2,
                              m:1,
                              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                              '&:hover': {
                                boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                backgroundColor:'#14213d',
                              },
                            }} 
                            onClick={createThing}
                            // disabled={loading}
                          >
                            {loading? <CircularProgress size='20'  /> : 'Update'}
                          </Button>
                        </Grid>

                      </Grid>
                    </Box>
                  </Modal>

            </Box>
            <Snackbar
                open={ope}
                autoHideDuration={3000}
                onClose={handleClo}
                message={message}
                action={actio}
            />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={backdrop_open}
                onClick={handleBackdropClose}
            >
                <CircularProgress color="secondary" />
            </Backdrop>

            </div>
  )
}
